var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-content',[_c('v-overlay',[_c('v-progress-circular',{staticClass:"maincolor",attrs:{"size":80,"width":2,"indeterminate":""}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }